import useGameContext from '~/client/components/Game/context/Game/useGameContext';
import useGameProvider from '~/client/components/Game/GameView/GameViewMobile/shared/hooks/useGameProvider';
import useRouter from '~/client/hooks/router/useRouter';
import useIsLoggedIn from '~/client/hooks/user/useIsLoggedIn';
import usePlayGame from '../../hooks/usePlayGame';

const useGameHeader = () => {
  const { game } = useGameContext();
  const { providerName, href } = useGameProvider();
  const isLoggedIn = useIsLoggedIn();
  const { canPlayFunMode, handlePlayForReal, handlePlayForFun } = usePlayGame();
  const { push } = useRouter();
  const handleClick = () => {
    if (!isLoggedIn && canPlayFunMode) {
      return handlePlayForFun();
    }
    if (!isLoggedIn && !canPlayFunMode) {
      return push('/login');
    }
    return handlePlayForReal();
  };
  return { game, providerName, href, handleClick };
};

export default useGameHeader;
